import React from 'react';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import { Heading1Text, TitleMedium } from '../../../Texts';
import Button from '../../../Button';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    padding: 50px 0px;
    gap: 40px;
  }
`;

const BackgroundColor = styled.div`
  background-color: ${({ theme }) => theme.primary.primary};
`;

const JoinNow = () => {
  const theme = useTheme();
  return (
    <BackgroundColor>
      <WidthContainer>
        <Container>
          <InnerContainer style={{ gap: 20, alignItems: 'flex-start' }}>
            <div>
              <Heading1Text style={{ color: 'white', width: '100%' }}>
                Join <span style={{ color: theme.special.purple }}>Now!</span>
              </Heading1Text>
              <TitleMedium style={{ color: 'white' }}>
                Apply now and get your personal referral link and media kit in
                minutes. Start earning USDC from every project you help grow—no
                cap, no limits.
                <br />
                <br />
              </TitleMedium>
            </div>
            <div style={{ marginTop: 20 }}>
              <Button
                as='a'
                href='https://calendly.com/kevin-deks/deks-platform-intro'
                target='_blank'
                rel='noopener noreferrer'
                variant='white'
              >
                APPLY NOW!
              </Button>
            </div>
          </InnerContainer>
          <InnerContainer>
            <img src='/joinNow.webp' />
          </InnerContainer>
        </Container>
      </WidthContainer>
    </BackgroundColor>
  );
};

export default JoinNow;
